import { GraphDto } from "@custom-types/graphs"
import { format } from "date-fns"

export const getLeftRows = (graph: GraphDto) => {
  return [
    {
      label: "Organisation",
      value: graph.product_organisation_key,
    },
    {
      label: "Product",
      value: graph.product_key,
    },
    {
      label: "Last updated",
      value: format(new Date(graph.last_updated), " RRRR-LL-dd HH:mm:ss"),
    },
  ]
}

export const getMiddleRows = (graph: GraphDto) => {
  return [
    {
      label: "Start date",
      value: graph.start_date,
    },
    {
      label: "End date",
      value: graph.end_date,
    },
    {
      label: "Frequency",
      value: graph.simulation_frequency,
    },
  ]
}

export const getRightRows = (graph: GraphDto) => {
  return [
    {
      label: "Rolling duration",
      value: graph.rolling_duration,
    },
    {
      label: "Yearly start month",
      value: graph.yearly_rolling_start_month,
    },
    {
      label: "Published",
      value: graph.published ? "Yes" : "No",
    },
  ]
}
